"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseExpiringStatus = void 0;
var LicenseExpiringStatus;
(function (LicenseExpiringStatus) {
    LicenseExpiringStatus["ACTIVE"] = "Active";
    LicenseExpiringStatus["EXPIRING"] = "Expiring";
    LicenseExpiringStatus["EXPIRED"] = "Expired";
})(LicenseExpiringStatus || (exports.LicenseExpiringStatus = LicenseExpiringStatus = {}));
